// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const jynx: PokeData = {
  "id": 124,
  "name": "jynx",
  "height": 14,
  "weight": 406,
  "base_experience": 159,
  "types": [
    PokeType.ICE,
    PokeType.PSYCHIC
  ],
  "api_moves": [
    "pound",
    "double-slap",
    "ice-punch",
    "body-slam",
    "thrash",
    "sing",
    "blizzard",
    "confusion",
    "psychic",
    "screech",
    "lick",
    "lovely-kiss",
    "powder-snow",
    "sweet-kiss",
    "perish-song",
    "mean-look",
    "fake-tears",
    "covet",
    "wake-up-slap",
    "wring-out",
    "copycat",
    "avalanche",
    "heart-stamp",
    "draining-kiss"
  ],
  "moves": [
    "ice-punch",
    "body-slam",
    "blizzard",
    "psychic",
    "lick",
    "sweet-kiss",
    "avalanche",
    "ice-fang",
    "prismatic-cage",
    "hailstorm",
    "psywave",
    "aurora-veil",
    "psy-ball"
  ],
  "evolution_chain": {
    "id": 59,
    "item": null,
    "species": [
      {
        "name": "smoochum",
        "order": 143,
        "types": [
          PokeType.ICE,
          PokeType.PSYCHIC
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "jynx",
        "order": 144,
        "types": [
          PokeType.ICE,
          PokeType.PSYCHIC
        ],
        "evolves_from_species_id": 238,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 30,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 95,
    "speed": 138,
    "ability_power": 167
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
